import React from 'react';
import { View } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import FoundationTestKeys from '../../FoundationTestKeys';
import { Icon } from '../Icon';
import VFText from '../VFText';

import styles from './AlertBanner.Styles';

function AlertBanner({
  alertMessage,
  alertMessagePlaceHolders,
  isVisible,
  icon,
  containerStyle,
  alertMessageStyle,
  ...props
}) {
  return (
    isVisible && (
      <View
        style={[styles.containerStyle, containerStyle]}
        testID={FoundationTestKeys.alertBannerView}
      >
        {icon && (
          <Icon
            name={icon}
            size={21}
            type="image"
            style={styles.icon}
            testID={FoundationTestKeys.alertBannerIcon}
          />
        )}
        <VFText
          i18nKey={alertMessage}
          placeHolders={alertMessagePlaceHolders}
          style={[styles.alertMessage, alertMessageStyle]}
          testKey={FoundationTestKeys.alertBannerText}
        />
      </View>
    )
  );
}

AlertBanner.defaultProps = {
  isVisible: false,
};

AlertBanner.propTypes = {
  alertMessage: PropTypes.string.isRequired,
  alertMessagePlaceHolders: PropTypes.array,
  isVisible: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ uri: PropTypes.string })]),
  containerStyle: ViewPropTypes.style,
  alertMessageStyle: TextPropTypes.style,
};

export default AlertBanner;
